import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["maximized", "onToggleMaximize", "onClose", "onClear", "canClear", "closeIconComponent", "minimizeIconComponent", "maximizeIconComponent", "titleIconComponent", "classNames", "translations"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { cx } from "../../lib/index.js";
import { createButtonComponent } from "../Button.js";
import { SparklesIcon, MaximizeIcon as MaximizeIconDefault, MinimizeIcon as MinimizeIconDefault, CloseIcon as CloseIconDefault } from "./icons.js";
export function createChatHeaderComponent(_ref) {
  var createElement = _ref.createElement;
  var Button = createButtonComponent({
    createElement: createElement
  });
  return function ChatHeader(userProps) {
    var _userProps$maximized = userProps.maximized,
      maximized = _userProps$maximized === void 0 ? false : _userProps$maximized,
      onToggleMaximize = userProps.onToggleMaximize,
      onClose = userProps.onClose,
      onClear = userProps.onClear,
      _userProps$canClear = userProps.canClear,
      canClear = _userProps$canClear === void 0 ? false : _userProps$canClear,
      CloseIcon = userProps.closeIconComponent,
      MinimizeIcon = userProps.minimizeIconComponent,
      MaximizeIcon = userProps.maximizeIconComponent,
      TitleIcon = userProps.titleIconComponent,
      _userProps$classNames = userProps.classNames,
      classNames = _userProps$classNames === void 0 ? {} : _userProps$classNames,
      userTranslations = userProps.translations,
      props = _objectWithoutProperties(userProps, _excluded);
    var translations = _objectSpread({
      title: 'Chat',
      minimizeLabel: 'Minimize chat',
      maximizeLabel: 'Maximize chat',
      closeLabel: 'Close chat',
      clearLabel: 'Clear'
    }, userTranslations);
    var defaultMaximizeIcon = maximized ? createElement(MinimizeIconDefault, {
      createElement: createElement
    }) : createElement(MaximizeIconDefault, {
      createElement: createElement
    });
    return createElement("div", _extends({
      className: cx('ais-ChatHeader', classNames.root, props.className)
    }, props), createElement("span", {
      className: cx('ais-ChatHeader-title', classNames.title)
    }, createElement("span", {
      className: cx('ais-ChatHeader-titleIcon', classNames.titleIcon)
    }, TitleIcon ? createElement(TitleIcon, null) : createElement(SparklesIcon, {
      createElement: createElement
    })), translations.title), createElement("div", {
      className: cx('ais-ChatHeader-actions')
    }, onClear && createElement(Button, {
      variant: "ghost",
      size: "sm",
      className: cx('ais-ChatHeader-clear', classNames.clear),
      onClick: onClear,
      disabled: !canClear
    }, translations.clearLabel), createElement(Button, {
      variant: "ghost",
      size: "sm",
      iconOnly: true,
      className: cx('ais-ChatHeader-maximize', classNames.maximize),
      onClick: onToggleMaximize,
      "aria-label": maximized ? translations.minimizeLabel : translations.maximizeLabel
    }, MaximizeIcon ? createElement(MaximizeIcon, {
      maximized: maximized
    }) : defaultMaximizeIcon), createElement(Button, {
      variant: "ghost",
      size: "sm",
      iconOnly: true,
      className: cx('ais-ChatHeader-close', classNames.close),
      onClick: onClose,
      "aria-label": translations.closeLabel,
      title: translations.closeLabel
    }, CloseIcon ? createElement(CloseIcon, null) : createElement(CloseIconDefault, {
      createElement: createElement
    }))));
  };
}